import { objectOf } from "@altostra/type-validations";
export const isAppsAppGroupIdAnalyticsReportSettingResult = objectOf({});
